<div class="error-container" *ngIf="noConnectionError">
    <h1> {{'CONNECTION_ERROR.NO_CONNECTION_TO_THE_SERVER' | translate}}</h1>
</div>